const hotels = [
 [
    {
      name: 'Daan Orchid Residency ',
      description:
        'Your premier destination in the heart of Kottayam town! Situated conveniently close to the KSRTC Bus Stand and the revered Thirunakkara Temple, our 3-star business hotel offers a tranquil retreat amidst the bustling city.',
      image: 'https://iili.io/Fo0ktGj.png',
      link: 'https://daanorchidresidency.com/'
    },
    {
      name: 'Premium Quality Rooms',
      description:
        'Choose from our selection of tastefully crafted rooms offers a warm and welcoming atmosphere, ensuring a relaxing experience throughout your stay. Also includes Banquet and Conference facilities',
      image: 'https://iili.io/FohHd67.png',
      link: 'https://daanorchidresidency.com/'
    },
    {
      name: "Our Vision",
      description:
        'focus on quality, reliability, and excellence, we go the extra mile to make your stay truly memorable. Whether you’re here for business or leisure, you can trust Us to provide a warm, comfortable, and hassle-free stay',
      image: 'https://iili.io/Foh2EPV.png',
      link: 'https://daanorchidresidency.com/'
    }
  ],
[
    {
      name: 'Daan Regency',
      description:
        'Daan Regency is here to red-letter your visit by providing you with the most desirable facilities that you will always cherish throughout your life and would prompt you to visit this cosy space often',
      image: 'https://i.postimg.cc/5t4pmwbs/daan1.png',
      link: 'https://daanregency.com/'
    },
    {
      name: 'Premium Quality Rooms',
      description:
        'A/C rooms, Intercom, Wi-Fi Enabled room, Sitting Table, 32-inch LED TV, 24 hrs Safety and security, Spotless linen, Tea coffee making facilities.',
      image: 'https://iili.io/FohojRV.png',
      link: 'https://daanregency.com/room'
    },
    {
      name: "Our Vision",
      description:
        'Positioned amid the bustling city life, Daan Regency offers an impeccable experience for our tenants by providing a serene stay devoid of the hustles of city life.',
      image: 'https://iili.io/FohowOB.png',
      link: 'https://daanregency.com/room'
    }
  ],
[
    {
      name: 'Daan Temple Inn',
      description:
        'Nestled in the heart of Guruvayoor, Daan Temple Inn offers an exquisite blend of luxury and spirituality.Just moments away from the sacred Guruvayoor Temple',
      image: 'https://iili.io/FohPB6v.png',
      link: 'https://daantempleinn.com/'
    },
    {
      name: 'Premium Quality Rooms',
      description:
        'Experience unparalleled comfort and convenience with our exceptional range of services and amenities designed to enhance your stay.perfect blend of elegant design and ultimate relaxation in every aspect',
      image: 'https://iili.io/FohPqMJ.png',
      link: 'https://daantempleinn.com/'
    },
    {
      name: "Our Vision",
      description:
        'designed to provide an oasis of comfort for devotees and travelers alike. Whether you’re visiting for pilgrimage, relaxation, or a grand celebration, Daan Temple Inn ensures a divine and opulent stay',
      image: 'https://iili.io/FohPfna.png',
      link: 'https://daantempleinn.com/'
    }
  ],
 [
    // {
    //   name: 'Urban 24 ',
    //   description:
    //     'At Urbn24, we blend comfort and convenience to provide a memorable stay for our guests , we are committed to offering the best in hospitality.',
    //   image: 'https://iili.io/FojxYcG.png',
    //   link: 'https://urbn24.in/'
    // },
    {
      name: 'Premium Quality Rooms',
      description:
        'Our 19-bedroom hotel offers a warm and welcoming atmosphere, ensuring a relaxing experience throughout your stay.',
      image: 'https://iili.io/Fojxl94.png',


      link: 'https://urbn24.in/'
    },
    {
      name: "Our Vision",
      description:
        'focus on quality, reliability, and excellence, we go the extra mile to make your stay truly memorable. Whether you’re here for business or leisure, you can trust Urbn24 to provide a warm, comfortable, and hassle-free stay',
      image: 'https://iili.io/Fojx7Fs.png',
      link: 'https://urbn24.in/'
    }
  ],
  [
    {
      name: 'Daan Inn ',
      description:
        'your cozy retreat in the vibrant heart of Kochi. Designed for travelers seeking comfort and simplicity, our hotel offers a tranquil space to unwind after a busy day in the city.',
      image: 'https://iili.io/Foj6pgR.png',
      link: 'https://daaninn.in//'
    },
    {
      name: 'Premium Quality Rooms',
      description:
        'At Daan Inn, we focus exclusively on providing exceptional stay experiences. Whether you’re here for business or leisure, our well-maintained rooms, warm hospitality, and attention to detail ensure a peaceful and memorable visit.',
      image: 'https://iili.io/Foj6bqJ.png',
      link: 'https://daaninn.in/'
    },
    {
      name: "Our Vision",
      description:
        'our vision to provide exceptional hospitality and unforgettable experiences for every guest that walks through our doors.Our attentive staff is committed to making your stay seamless and enjoyable.',
      image: 'https://iili.io/FojP9Jp.png',
      link: 'https://daaninn.in/'
    }
  ],
// [
//     {
//       name: 'Daan Residency',
//       description:
//         'Daan Residency offers a perfect blend of sophistication and comfort. Whether you are here for business, leisure, or a spiritual retreat, our well-appointed rooms and impeccable service ensure an unforgettable stay.',
//       image: 'https://iili.io/FowjCPt.png',
//       link: 'https://daanresidency.in/'
//     },
//     {
//       name: 'Premium Quality Rooms',
//       description:
//         'Our commitment to excellence, attention to detail, and warm hospitality make us a preferred choice for travelers seeking comfort and convenience. Whether you’re visiting for business, leisure, or a spiritual retreat, we ensure a seamless and memorable stay with personalized service and world-class amenities.',
//       image: 'https://iili.io/Fowjxln.png',
//       link: 'https://daanresidency.in/'
//     },
//     {
//       name: "Our Vision",
//       description:
//         'Our vision is to create a home away from home, where guests can unwind, rejuvenate, and create lasting memories. Located in the heart of kochi, we offer the perfect balance of luxury and affordability, making every moment of your stay truly special.',
//       image: 'https://iili.io/FowjoKX.png',
//       link: 'https://daan.in/'
//     }
//   ],
  // [

    // {
    //   name: 'Amala Arcade',
    //   description:
    //     'Looking for a cozy and affordable place to stay while supporting your loved ones at Amala Multi Specialty Hospital? Look no further!',
    //   image: 'https://iili.io/FowPNS4.png',
    //   link: 'https://amalaarcade.com/'
    // },

    // {
    //   name: 'Premium Quality Rooms',
    //   description:
    //     'We understand the importance of being close to your family during times of need, and that’s why we’ve created a warm, inviting atmosphere where you can truly feel at home.',
    //   image: 'https://iili.io/FowPjKG.png',
    //   link: 'https://amalaarcade.com/rooms/'
    // },
    // {
    //   name: "Our Vision",
    //   description:
    //     'Experience unparalleled comfort and convenience with our exceptional range of services and amenities designed to enhance your stay.',
    //   image: 'https://iili.io/FowPwlf.png',
    //   link: 'https://amalaarcade.com/'
    // }
  // ],
  // [
    // {
    //   name: 'Daan South Park',
    //   description:
    //     ' Located 32 km from Cochin International Airport, the hotel is near attractions such as Cochin Shipyard (16-minute walk), Ernakulam Railway Station (400 metres), and Ernakulam Public Library (2 km). Boating is available in the surroundings.',
    //   image: 'https://iili.io/FoNBk4s.png',
    //   link: 'https://www.booking.com/hotel/in/daan-south-park.en-gb.html?aid=357028&label=bin859jc-1FCAsobEIPZGFhbi1zb3V0aC1wYXJrSDNYA2hsiAEBmAEJuAEXyAEM2AEB6AEB-AEDiAIBqAIDuALqjPXBBsACAdICJDI4NDAxYWU1LWFjNDktNDMyMi05OTc2LWZkOTdmY2YxNzNkYtgCBeACAQ&sid=e8aa6d68ffa841b312fa52746b65c647&dest_id=-2093645&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1750315098&srpvid=6d712ea98fe7045a&type=total&ucfs=1&'
    // },
    // {
    //   name: 'Premium Quality Rooms',
    //   description:
    //     ' DAAN South Park in Kochi offers family-friendly rooms with private bathrooms, air-conditioning, and free WiFi. Each room includes a work desk, TV, and soundproofing for a pleasant stay.',
    //   image: 'https://iili.io/FoNBOCX.png',
    //   link: 'https://www.booking.com/hotel/in/daan-south-park.en-gb.html?aid=357028&label=bin859jc-1FCAsobEIPZGFhbi1zb3V0aC1wYXJrSDNYA2hsiAEBmAEJuAEXyAEM2AEB6AEB-AEDiAIBqAIDuALqjPXBBsACAdICJDI4NDAxYWU1LWFjNDktNDMyMi05OTc2LWZkOTdmY2YxNzNkYtgCBeACAQ&sid=e8aa6d68ffa841b312fa52746b65c647&dest_id=-2093645&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1750315098&srpvid=6d712ea98fe7045a&type=total&ucfs=1&'
    // },
    // {
    //   name: "Our Vision",
    //   description:
    //     'Experience unparalleled comfort and convenience with our exceptional range of services and amenities designed to enhance your stay.The on-site restaurant serves Indian cuisine with halal options. Guests can enjoy brunch, lunch, and dinner in a welcoming ambience.',
    //   image: 'https://iili.io/FoNB83G.png',
    //   link: 'https://www.booking.com/hotel/in/daan-south-park.en-gb.html?aid=357028&label=bin859jc-1FCAsobEIPZGFhbi1zb3V0aC1wYXJrSDNYA2hsiAEBmAEJuAEXyAEM2AEB6AEB-AEDiAIBqAIDuALqjPXBBsACAdICJDI4NDAxYWU1LWFjNDktNDMyMi05OTc2LWZkOTdmY2YxNzNkYtgCBeACAQ&sid=e8aa6d68ffa841b312fa52746b65c647&dest_id=-2093645&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1750315098&srpvid=6d712ea98fe7045a&type=total&ucfs=1&'
    // }
  // ],
[
    {
      name: 'Meridian By Daan',
      description:
        'MERIDIAN BY Daan in Thiruvananthapuram offers family rooms with air-conditioning, private bathrooms, work desks, free toiletries, showers, TVs, and wardrobes. Guests enjoy free WiFi, private check-in and check-out, and a 24-hour front desk',
      image: 'https://iili.io/FxBwVwP.png',
      link: 'https://be.aiosell.com/book/d53b872227'
    },
    {
      name: 'Premium Quality Rooms',
      description:
        ' The hotel features a lounge, minimarket, electric vehicle charging station, outdoor seating area, bicycle parking, and free private parking. Additional services include a paid shuttle, room service, tour desk, and express check-in and check-out.',
      image: 'https://iili.io/FxBwhoF.png',
      link: 'https://be.aiosell.com/book/d53b872227'
    },
    {
      name: "Our Vision",
      description:
        'Located 16 km from Thiruvananthapuram International Airport, the hotel is near attractions such as Sree Padmanabhaswamy Temple (14 km), Napier Museum (15 km), and Vellayani Lake (6 km). Guests appreciate the room comfort, family-friendliness, and family rooms.',
      image: 'https://iili.io/FxBwWt1.png',
      link: 'https://be.aiosell.com/book/d53b872227'
    }
  ],
];
   export default hotels;